import getBillInvoiceSlice from "./getBillInvoiceSlice";
import getBillingHistorySlice from "./getBillingHistorySlice";
import getSubscriptionListSlice from "./getSubscriptionListSlice";

export const allSubscriptionSlices = {
  getSubscriptionList: getSubscriptionListSlice,
  getBillingHistory: getBillingHistorySlice,
  getBillInvoice: getBillInvoiceSlice,
};
